<template>
  <div class="card-form">
    <el-row :gutter="10">
      <el-col :span="8">
        <left-table />
      </el-col>
      <el-col :span="16">
        <right-table />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import LeftTable from './components/left-table'
import RightTable from './components/right-table'
export default {
  name: 'scm-inputTemplate',
  components: {
    LeftTable,
    RightTable
  }
}
</script>
